<!-- 基金持股图表组件 -->
<template>
	<div v-if="data.length" class="chart-wrapper">
		<LineBarChart
			:seriesData="data"
			:tooltip-label="$t('enterprise.total-of-holdings')"
			custom-style="fund_holding"
			@data-checked="onDataChecked"
		/>
	</div>
</template>

<script setup>
import LineBarChart from '@/components/LineBarChart.vue';

// Props 定义
const props = defineProps({
	// 图表数据
	data: {
		type: Array,
		default: () => []
	},
	barChartMap: {
		type: Map,
		default: () => new Map()
	}
});

// Events 定义
const emit = defineEmits(['bar-checked']);


// 图表点击事件
const onDataChecked = ({ data }) => {
	const value = props.barChartMap.get(data);
	emit('bar-checked', value);
};
</script>

<style lang="less" scoped>
.chart-wrapper {
	width: 100%;
	height: 256px;
}
</style>
